import React from "react";

const ChefeSection = () => {
  return (
    <>
      {/* Chefe Section Start */}
      <section className="chefe-section fix section-padding bg-color2">
        <div className="chefe-wrapper style1">

          {/* Shapes */}
          <div className="shape1 d-none d-xxl-block">
            <img
              className="float-bob-y"
              src="/assets/img/shape/chefeShape1_1.png"
              alt="shape"
            />
          </div>

          <div className="shape2 d-none d-xxl-block">
            <img
              className="float-bob-x"
              src="/assets/img/shape/chefeShape1_2.png"
              alt="shape"
            />
          </div>

          <div className="container">

            {/* Title */}
            <div className="title-area">
              {/* <div
                className="sub-title text-center wow fadeInUp"
                data-wow-delay="0.5s"
              >
                <img
                  className="me-1"
                  src="/assets/img/icon/titleIcon.svg"
                  alt="icon"
                />
                OUR CHEFE
                <img
                  className="ms-1"
                  src="/assets/img/icon/titleIcon.svg"
                  alt="icon"
                />
              </div> */}

              <h2 className="title wow fadeInUp" data-wow-delay="0.7s">
               Why Choose Us
              </h2>
            </div>

            {/* Chefe Cards */}
            <div className="chefe-card-wrap style1 pb-5">
              <div className="row">

                {/* Card 1 */}
                <div className="col-lg-6 col-xl-4">
                  <div
                    className="chefe-card style1 wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="chefe-thumb">
                      <img
                        src="/assets/img/chefe/1.jpg"
                        alt="thumb"
                      />
                    </div>

                    {/* <div className="icon">
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fa-light fa-share-nodes"></i>
                      </a>
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                    </div> */}

                    <div className="chefe-content">
                      <a href="/chef-details">
                        <h3>15+ Years of Experience</h3>
                      </a>
                      <p>Trusted catering expertise </p>
                    </div>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="col-lg-6 col-xl-4">
                  <div
                    className="chefe-card style1 wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="chefe-thumb">
                      <img
                        src="/assets/img/chefe/5.jpg"
                        alt="thumb"
                      />
                    </div>

                    {/* <div className="icon">
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fa-light fa-share-nodes"></i>
                      </a>
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                    </div> */}

                    <div className="chefe-content">
                      <a href="/chef-details">
                        <h3>100% Customizable Menus</h3>
                      </a>
                      <p>Designed to your choice.</p>
                    </div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="col-lg-6 col-xl-4">
                  <div
                    className="chefe-card style1 wow fadeInUp"
                    data-wow-delay="0.5s"
                  >
                    <div className="chefe-thumb">
                      <img
                        src="/assets/img/chefe/4.jpg"
                        alt="thumb"
                      />
                    </div>

                    {/* <div className="icon">
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fa-light fa-share-nodes"></i>
                      </a>
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                    </div> */}

                    <div className="chefe-content">
                      <a href="/chef-details">
                        <h3>Fresh & Hygienic Ingredients</h3>
                      </a>
                      <p>Pure, safe and quality food.</p>
                    </div>
                  </div>
                </div>

                {/* Card 4
                <div className="col-lg-6 col-xl-4">
                  <div
                    className="chefe-card style1 wow fadeInUp"
                    data-wow-delay="0.5s"
                  >
                    <div className="chefe-thumb">
                      <img
                        src="/assets/img/chefe/chefeThumb1_3.png"
                        alt="thumb"
                      />
                    </div>

                    <div className="icon">
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a href="#">
                        <i className="fa-light fa-share-nodes"></i>
                      </a>
                      <a className="hovered-icon" href="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                    </div>

                    <div className="chefe-content">
                      <a href="/chef-details">
                        <h3>Ronald Richards</h3>
                      </a>
                      <p>Chef Assistant</p>
                    </div>
                  </div>
                </div> */}

              </div>
            </div>

            {/* Client Slider */}
            {/* <div
              className="slider-area pt-5 mt-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="swiper clientSliderOne">
                <div className="swiper-wrapper">

                  {[1, 2, 3, 4, 5, 6].map((item) => (
                    <div className="swiper-slide" key={item}>
                      <div className="client-img text-center">
                        <img
                          src={`/assets/img/logo/clientLogo1_${item}.png`}
                          alt="logo"
                        />
                      </div>
                    </div>
                  ))}

                </div>
              </div>
            </div> */}

          </div>
        </div>
      </section>
      {/* Chefe Section End */}
    </>
  );
};

export default ChefeSection;
